import { FormattedDateTime, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { getCurrentLocale } from '../../../../utils'

interface DocumentDateProps {
  date?: string | null
}

export const DocumentDate = ({ date }: DocumentDateProps): ReactElement => {
  const locale = getCurrentLocale()
  const dateValue = date ? new Date(date) : undefined

  return (
    <Text alignment="left" colorVariant="primary" variant="bodySM" weight="bold">
      <FormattedDateTime.Date value={dateValue} locale={locale} />
    </Text>
  )
}
